import { all, call, put, takeLatest } from 'redux-saga/effects';

import { getTitle, getFile } from './APIs/doc';
import { getApiErrorMessage } from 'utils/apiError';

import types from '../constants/documentConstants';

import {
  setDocTitleAction,
  setErrorAction,
  setDocFileAction,
  setDocLoadingAction,
} from '../actions/documentActions';

function* getDocTitleSaga({ payload }) {
  try {
    const res = yield getTitle(payload);
    yield put(setDocTitleAction(res));
  } catch (error) {
    yield put(setErrorAction(getApiErrorMessage(error, 'Failed to load documents.')));
  }
}

function* onGetDocTitle() {
  yield takeLatest(types.GET_DOCTITLE, getDocTitleSaga);
}

function* getDocFileSaga({ payload }) {
  try {
    yield put(setDocLoadingAction(true));
    const res = yield getFile(payload);
    yield put(setDocFileAction(res));
  } catch (error) {
    yield put(setErrorAction(getApiErrorMessage(error, 'Failed to download document.')));
  } finally {
    yield put(setDocLoadingAction(false));
  }
}

function* onGetDocFile() {
  yield takeLatest(types.GET_DOCFILE, getDocFileSaga);
}

export default function* docSaga() {
  yield all([call(onGetDocTitle), call(onGetDocFile)]);
}
